import React, { createContext, useContext, useState, ReactNode, useEffect } from "react"
import { useCamp } from "~/api2/hooks/useCamp"
import { useMe } from "~/api2/hooks/useMe"
import Spinner from "~/components/ui/Spinner"

interface GlobalLoaderContextValue {}
const GlobalLoaderContext = createContext<GlobalLoaderContextValue>({})

export const GlobalLoaderProvider = ({ children }: { children: ReactNode }) => {
  const {
    index: { isLoading: isLoadingCamp, data: camp },
  } = useCamp()
  const { isLoading: isLoadingUser, data: user } = useMe()
  const [initialLoadDone, setInitialLoadDone] = useState(false)

  useEffect(() => {
    if (!isLoadingCamp && camp && !isLoadingUser && user && !initialLoadDone) {
      setInitialLoadDone(true)
    }
  }, [isLoadingCamp, camp, isLoadingUser, user, initialLoadDone])

  const isLoading = !initialLoadDone && (isLoadingCamp || !camp || isLoadingUser || !user)

  return (
    <GlobalLoaderContext.Provider value={{}}>
      {isLoading ? (
        <div className="w-screen h-screen flex justify-center items-center">
          <Spinner size={5} />
          <div className="">Loading your camp...</div>
        </div>
      ) : (
        children
      )}
    </GlobalLoaderContext.Provider>
  )
}

export const useCampContext = () => useContext(GlobalLoaderContext)
